export default __webpack_public_path__ + "static/media/65_desktop.c1572b28.jpg";